import { theme } from 'theme';
import { pxToEmValue } from './pxToEm';

export const scalingEm = (
  min = 0,
  max = 1,
  useHeight = false,
  minDim = theme.breakpoints.values.md,
  maxDim = theme.breakpoints.values.lg,
): string => {
  minDim = pxToEmValue(minDim);
  maxDim = pxToEmValue(maxDim);

  return scalingValue(min, max, 'em', useHeight, minDim, maxDim);
};

export const scalingPx = (
  min = 0,
  max = 1,
  useHeight = false,
  minDim = theme.breakpoints.values.md,
  maxDim = theme.breakpoints.values.lg,
): string => {
  return scalingValue(min, max, 'px', useHeight, minDim, maxDim);
};

export const scalingValue = (
  min = 0,
  max = 1,
  unit = 'px',
  useHeight = false,
  minDim = theme.breakpoints.values.md,
  maxDim = theme.breakpoints.values.lg,
): string => {
  const scale = `clamp(0${unit}, (100v${
    useHeight ? 'h' : 'w'
  } - ${minDim}${unit})/(${maxDim} - ${minDim}), 1${unit})`;
  return `calc((${max} - ${min})*${scale} + ${min}${unit})`;
};

export const scalingFontSize = (
  min = 16,
  max = 30,
  minDim = theme.breakpoints.values.md,
  maxDim = theme.breakpoints.values.xl,
): string => {
  min = pxToEmValue(min);
  max = pxToEmValue(max);

  return scalingEm(min, max, false, minDim, maxDim);
};
